// extracted by mini-css-extract-plugin
module.exports = {"margin_back":"NotEligibleFishingTruck_margin_back__1RHYh"};